import DiabloService from '../lib/DiabloService'

/**
 * 获取医生信息
 * @param doctorId
 */
const getDoctorInfo = (doctorId) => {
  return Promise.resolve({})
};

/**
 * 获取私人医生历史消息
 * 19000 相关问诊单已存在的消息不拉取 不然会拉出很多不展示的人机控制消息
 * @param userId
 * @param doctorId
 */
const getHistoryMsgs = (userId, doctorId, personId, lastMsgId, size = 20) => {
  return DiabloService.getPersonMessage({
    personId,
    entranceDoctorId: doctorId,
    chatUserId: userId, //@todo 怎么获取
    lastMsgId: lastMsgId || 0,
    size
  })
}

/**
 * 获取udp信息
 * @param doctorId
 */
const getUserAndDoctorInfo = (doctorId) => {
  return Promise.all([DiabloService.getUserInfo(), DiabloService.getDoctorInfo(doctorId)]).then(
    ([userInfo, doctorInfo]) => {
      return {
        userInfo,
        doctorInfo,
      };
    }
  );
};

/**
 * 上传主诉
 * @param doctorId
 */
const uploadImEvent = (parament) => {
  DiabloService.uploadImEvent(parament)
};

/**
 * 获取离线消息列表
 */
const loadOfflineMsgs = (msgLastId, personId) => {
  return DiabloService.getChatOfflineMessageWithPerson({
    lastId: msgLastId || '0',
    personId,
  });
};

/**
 * 对话框类型
 */
const DIALOGMODE = {
  BIND: 1, // 绑定模式
  ONDUTY_NO_ORDER: 2, // 值班模式-无单
  ONDUTY_WITH_ORDER: 3, // 值班模式-有单 需要展示值班医生接诊中
  LEAVEMSG: 4, // 留言模式
  UNBIND: 5, // 解绑模式 对话框失效
};

/**
 * 对话框状态
 */
const DIALOGSTATUS = {
  INVALID: 0, // 无效
  VALID: 1, // 有效
};

/**
 * 获取消息盒子中未读消息
 * @param entranceDoctorId
 * @param personId
 */
const getUnreadInboxMsg = (entranceDoctorId, personId) => {
  return DiabloService.getUnreadInboxMsg({
    query: JSON.stringify({
      entranceDoctorId,
      personId,
    }),
  });
};

/**
 * 查询用户与家庭医生是否为微信好友
 * @param {*} doctorId 
 * @returns 
 */
const getWxRelation = (doctorId) => {
  return DiabloService.getWxRelation({
    doctorId
  });
}

export {
  DIALOGMODE,
  getUserAndDoctorInfo,
  getHistoryMsgs,
  loadOfflineMsgs,
  getUnreadInboxMsg,
  getWxRelation,
  uploadImEvent
};
